import { StyleProp, View, ViewStyle } from "react-native";
import { SignedUrl } from "src/api/graphql/__generated__/graphql";
import { ReactionAssetDisplay } from "src/components/ReactionBadge";

const LargeReactionAssetCluster = ({
	numPrimaryReaction,
	reactionAsset,
	style,
}: {
	numPrimaryReaction: number;
	reactionAsset:
		| {
				emoji?: string | null | undefined;
				url?: SignedUrl | null | undefined;
		  }
		| null
		| undefined;
	style?: StyleProp<ViewStyle>;
}) => {
	const numClustered = numPrimaryReaction > 10 ? 3 : numPrimaryReaction > 5 ? 2 : 1;

	return (
		<View
			pointerEvents="none"
			style={[
				{
					width: 340,
					height: 160,
					alignItems: "center",
					justifyContent: "center",
					overflow: "hidden",
				},
				style,
			]}
		>
			{numClustered > 2 && (
				<ReactionAssetDisplay
					sizeVariant="xxl"
					reactionAsset={reactionAsset}
					style={{
						position: "absolute",
						transform: [
							{
								rotate: "-16deg",
							},
							{ translateX: -80 },
							{ translateY: -20 },
							{
								scale: 0.8,
							},
						],
						opacity: 0.8,
					}}
				/>
			)}
			{numClustered > 1 && (
				<ReactionAssetDisplay
					sizeVariant="xxl"
					reactionAsset={reactionAsset}
					style={{
						position: "absolute",
						transform: [
							{
								rotate: "20deg",
							},
							{ translateX: 70 },
							{ translateY: -32 },
							{
								scale: 0.7,
							},
						],
						opacity: 0.8,
					}}
				/>
			)}
			<ReactionAssetDisplay
				sizeVariant="xxl"
				reactionAsset={reactionAsset}
				style={{
					position: "absolute",
				}}
			/>
		</View>
	);
};
export default LargeReactionAssetCluster;
